import { destroyEcho } from '@/utils/echo';

export default {
    namespaced: true,

    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    },

    getters: {
        userInfo: (state) => state.userInfo || {},
    },

    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload;
            localStorage.setItem('userInfo', JSON.stringify(payload));
        },
        clearAuth(state) {
            state.userInfo = null;
            localStorage.removeItem('userInfo');
            localStorage.removeItem('token');
        },
    },

    actions: {
        fetchUser({ commit }, userId) {
            const token = localStorage.getItem('token');
            if (!token) {
                console.warn('No access token found. Skipping fetchUser.');
                return Promise.resolve();
            }

            return fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch user: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    commit('setUserInfo', data.data);
                })
                .catch((error) => {
                    console.error('Error fetching user:', error);
                    commit('clearAuth');
                });
        },
        updateUser({ commit }, updatedUser) {
            commit('setUserInfo', updatedUser);
        },
        /**
         * Свежо подтянуть данные текущего пользователя с бэка (включая role_id).
         * Используется админским роут-гардом — нельзя опираться на устаревший userInfo
         * из localStorage, потому что роль может быть изменена админом без релогина.
         *
         * Возвращает обновлённый userInfo либо null если что-то пошло не так
         * (нет токена / нет id / бэк ответил ошибкой).
         */
        async refreshCurrentUser({ commit, state }) {
            const token = localStorage.getItem('token');
            const userId = state.userInfo?.id;
            if (!token || !userId) {
                return null;
            }
            try {
                const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    return null;
                }
                const body = await response.json();
                const fresh = body?.data || null;
                if (fresh) {
                    commit('setUserInfo', fresh);
                }
                return fresh;
            } catch (e) {
                return null;
            }
        },
        logout({ commit }) {
            commit('clearAuth');
            // Сбрасываем гостевой session_token: иначе после логаута он остаётся
            // в localStorage, а треды, созданные под авторизацией, имеют
            // session_token=null в БД — гость по старому токену получит 403 на
            // broadcasting/auth. Чистый выход = новая гостевая сессия.
            try { localStorage.removeItem('chat_session_token'); } catch { /* noop */ }
            // Закрываем WS-соединение, иначе следующий логин подхватит чужие
            // подписки (chat.thread.* / support.user.*) с предыдущим token'ом.
            try { destroyEcho(); } catch { /* noop */ }
        },
    },
};
